module.exports = __webpack_public_path__ + "img/tutorial_simulated_01.266ec646.gif";